<template>
  <div class="main-container">
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import base from '@/api/base'
import { getUserInfo } from '@/api/user'
import { setUserInfo } from '@/api/micro'
import { getToken } from '@/utils/auth'
const uploadImgUrl = `${base.api}/micro/file/minio/upload`
import { isAdminApi } from '@/api/user'

export default {
  data() {
    return {
      uploadImgUrl,
      activeMenuIndex: 0,
      data: {},
      list: [],
      infoList: [
        {
          name: '个人信息',
          path: 'myuserinfo',
          value: 'myuserinfo',
          icon: 'geren',
        },
        {
          name: '用户积分',
          path: 'userCredit',
          value: 'userCredit',
          icon: 'geren',
        },
        {
          name: '组织积分',
          path: 'organizationCredit',
          value: 'organizationCredit',
          icon: 'geren',
        },
        {
          name: '账户安全',
          path: 'account',
          value: 'account',
          icon: 'anquan',
        },
        {
          name: '消息中心',
          path: 'message/:id',
          value: 'message',
          icon: 'message',
        },
      ],
      infoListNozzjf: [
        {
          name: '个人信息',
          path: 'myuserinfo',
          value: 'myuserinfo',
          icon: 'geren',
        },
        {
          name: '用户积分',
          path: 'userCredit',
          value: 'userCredit',
          icon: 'geren',
        },
        {
          name: '账户安全',
          path: 'account',
          value: 'account',
          icon: 'anquan',
        },
        {
          name: '消息中心',
          path: 'message/:id',
          value: 'message',
          icon: 'message',
        },
      ],
      token: getToken(),
      imageIcon: '',
    }
  },
  computed: {
    routePath() {
      return this.$route.name
    },
  },
  mounted() {},
  created() {
    this.getUserInfo()
  },
  watch: {},
  methods: {
    //上传图片
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        console.log('info.file: ', info.file)
        const { data, status, message } = info.file?.response
        if (!status) {
          this.loading = false
          setUserInfo({
            imageUrl: data.downloadPath,
          })
            .then((res) => {
              if (!res.status) {
                this.getUserInfo()
                this.$message.success('更新成功')
              } else {
                this.$message.error(res.message || '上传失败')
              }
            })
            .catch((err) => {
              this.$message.error(err.message || '上传失败')
            })
        } else {
          this.$message.error(message || '上传失败')
        }
        // Get this url from response in real world.
      }
    },
    //上传之前
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp' ||
        file.type === 'image/x-icon' ||
        file.type === 'image/webp'

      if (!isJpgOrPng) {
        this.$message.error('当前图片格式不支持!')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片不能大于10MB!')
      }
      return isJpgOrPng && isLt10M
    },
    getUserInfo() {
      getUserInfo()
        .then((res) => {
          const { data } = res
          this.data = data
          this.imageIcon = data.headshot
        })
        .catch(() => {})
    },
    // 查询是否是企业管理员
    getisAdmin() {
      let params = {
        userId: this.data.userId,
      }
      isAdminApi(params)
        .then((res) => {
          if (res.status == 0) {
            if (res.success) {
              this.list = this.infoList
            } else {
              this.list = this.infoListNozzjf
            }
          }
        })
        .catch((res) => {
          this.list = this.infoListNozzjf
        })
    },
    goTab(item, ind) {
      this.activeMenuIndex = ind
      if (item.path == 'message') {
        this.$router.push({ path: `user-info/message/${null}` })
      } else {
        this.$router.push({ path: '/user-info/' + item.path })
      }
    },
    upgrade() {
      this.$router.push('/user-info/member')
    },
  },
}
</script>

<style lang="less" scoped>
.main-container {
  width: 100%;
  height: 100%;
  margin-top: 60px;
  background-color: black;
}
</style>
